import { DatePipe } from '@angular/common';
import { Component, OnInit, inject, DestroyRef, ViewChild, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { SchedulerService } from 'src/app/services/api/scheduler.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import cronstrue from 'cronstrue';
import { RouterSegments } from 'src/app/models/router-segments';
import {AuthService} from 'src/app/services/auth/auth.service';
import { ColumnFilterComponent } from '../../instances-mgmt/column-filter/column-filter.component';
import moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { Permissions, Datazone, Attributes } from 'src/app/models/principal/permission';
import { TenantService } from 'src/app/services/api/tenant.service';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { EnvironmentTableComponent } from '../environment-table/environment-table.component';
import { EnvScheduleService } from 'src/app/services/api/env-schedule.service';
import { EnvironmentPaginatorComponent } from '../environment-paginator/environment-paginator.component';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { InstancesService } from 'src/app/services/api/instances.service';
import { EditRunbookService } from 'src/app/services/api/edit-runbook.service';
import { Constants } from 'src/app/models/constants';
import { FeatureFlagsManagerService } from 'src/app/services/util/feature-flags-manager.service';
import { FeatureFlags } from 'src/app/models/constants/feature-flags.constant';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.SCHEDULE_READ_NONPII,
    action: Permissions. AWS_SCHEDULE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.SCHEDULE_CREATE_NONPII, 
    action: Permissions. AWS_SCHEDULE_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.SCHEDULE_UPDATE_NONPII, 
    action: Permissions. AWS_SCHEDULE_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.SCHEDULE_READ_PII,
    action: Permissions. AWS_SCHEDULE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.SCHEDULE_CREATE_PII,
    action: Permissions. AWS_SCHEDULE_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.SCHEDULE_UPDATE_PII,
    action: Permissions. AWS_SCHEDULE_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.SCHEDULE_READ_LIVE,
    action: Permissions. AWS_SCHEDULE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.SCHEDULE_CREATE_LIVE,
    action: Permissions. AWS_SCHEDULE_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.SCHEDULE_UPDATE_LIVE,
    action: Permissions. AWS_SCHEDULE_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];

@Component({
  selector: 'app-environment-schedule',
  templateUrl: './environment-schedule.component.html',
  styleUrl: './environment-schedule.component.scss',
  standalone: false
})
export class EnvironmentScheduleComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
PermissionKeys = PermissionKeys;
Datazone = Datazone;        
@ViewChild(EnvironmentPaginatorComponent) paginatorRef: EnvironmentPaginatorComponent;
@ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;
@Input() instance: any;
readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.INITIALIZED, DeployStatus.INITIALIZING, DeployStatus.INITIALIZE_FAILED,
    DeployStatus.DEPLOYING, DeployStatus.TERMINATED, DeployStatus.TERMINATION_FAILED, DeployStatus.TERMINATING,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.TESTING, DeployStatus.FAILED,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING,
    DeployStatus.OPERATION_INPROGRESS, DeployStatus.TENANT_AGENT_CREATION_IN_PROGRESS, DeployStatus.START_FAILED, DeployStatus.STOP_FAILED, DeployStatus.STARTING,
    DeployStatus.STOPPING, DeployStatus.STOPPED, DeployStatus.STARTING_AGENT, DeployStatus.STOPPING_AGENT, DeployStatus.INPROGRESS];
  tenantId: string;
  scheduleLoading = true;
  runbookLength = 0;
  displayColumns = [
    {
      key: 'selected',
      name: '',
      type: 'radioSelection',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'name',
      name: 'SCHEDULE.SCHEDULE_NAME',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
      keyLink: 'navigation'
    },
    {
      key: 'runbookName',
      name: 'SCHEDULE.RUNBOOK',
      type: 'text',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'status',
      name:  'SCHEDULE.STATUS',
      type: 'status',
      visible: true,
      disable: true,
      sortable: true
    },
    {
      key: 'action',
      name: 'SCHEDULE.ACTIONS',
      type: 'scheduleAction',
      sortable: false,
      visible: true,
      disable: true
    },
    {
      key: 'scheduleSettings',
      name: '',
      type: 'settings',
      visible: true,
      disable: true
    }
  ];

  showLoader: boolean = true;
  schedule: any;
  data:any;
  searchTerm: string = '';
  showCreateNew: boolean;
  selectedData: any;
  editEnable: boolean;
  pageName = 'schedule';
  scheduleStatus: any;
  status: any;
  isAWS: boolean;
  searchedResult = [];
  isRefreshing = false;

  dropdownsList: any = [{ options: [] }, { options: [] }];
  runbookType: any;
  filteredColumns: any;
  clearData: boolean;
  filterStartDate: any;
  filterEndDate: any;
  selectedStatus = [];
  selectedType = [];
  selectedVersion = [];
  date:any;
  instanceId: any;
  isFiltered = false;
  envScheduleResponse = false;
  apiNotFound = false;
  pageIndex = 0;
  paginationSize = 10;
  runbookVersion: any;
  scheduleLoding = true;
  disableCreate = true;
  @Output() goToJobs = new EventEmitter<any>();
  scheduledStatusValue: any;
  deployingStatus: boolean;
  permissionsMap: { [key: string]: boolean };
  showSchedule = false; 
  createSchedule = false; 
  isDataLoaded = false; 
  enablingDisablingStates = ['enabling', 'disabling']
  isEditScheduleAllowed:boolean = false;
  restrictEnableDisable:boolean = false;
  azureScheduleStateEnabled: boolean = false;
  Constants = Constants;
  private featureFlagsManager = inject(FeatureFlagsManagerService);

  constructor(private activatedRoute: ActivatedRoute, private router: Router, public authService:AuthService,
    public schedulerService: SchedulerService, public sidenavService: SidenavService, public instanceService: InstancesService,
    private toastrService: CustomToastrService, private permissionsService: PermissionsService, public datePipe: DatePipe, private EditRunbookService: EditRunbookService,
    private dialog: MatDialog, public tenantService: TenantService, private cdr: ChangeDetectorRef, private envScheduleService: EnvScheduleService) {
    
  }

  async ngOnInit(): Promise<void> {
    await this.loadPermissions();
    this.getInstanceDetails();
    if (!this.INSTANCE_DEPLOYING_STATES.includes(this.instance?.status)) {
      this.disableCreate = false;
    }
      this.tenantService.tenantData$.subscribe((data: any) => {
        this.isAWS = data === CloudProvider.AWS ? true : false;
      });
      this.tenantId = this.activatedRoute.snapshot.params.id;
      this.instanceId = this.activatedRoute.snapshot.params.instanceId;
      if (localStorage.getItem('filteredEnvScheduleStatus')) {
        const userData = JSON.parse(localStorage.getItem('filteredEnvScheduleStatus'));
        if (userData) {
          this.selectedStatus = userData;
          this.scheduleStatus = this.selectedStatus;
          this.dropdownsList?.[0]?.options?.forEach(element => {
            if(this.selectedStatus.find(item=> item === element.value)) {
              element.selected = true;
            }
          });
        }
      }
      if (localStorage.getItem('filteredEnvScheduleCustomDate')) {
        const dateData = JSON.parse(localStorage.getItem('filteredEnvScheduleCustomDate'));
        if (dateData) {
          this.date = dateData;
          this.dropdownsList[1].options.forEach(element => {
            if(dateData.find(item=> item === element.value)) {
              element.selected = true;
            }
          });
        }
      }
    if (this.showSchedule) {
      this.fetchSchedule();
      this.resetEnvscheduleFilter();
    }
    }

  private async loadPermissions() {
    this.scheduleLoading = true;
    const dataZone = await this.initDataZone();
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.showSchedule = (this.permissionsMap[PermissionKeys.SCHEDULE_READ_NONPII] && dataZone === Datazone.NONPII) || (this.permissionsMap[PermissionKeys.SCHEDULE_READ_PII] && dataZone === Datazone.PII) || (this.permissionsMap[PermissionKeys.SCHEDULE_READ_LIVE] && dataZone === Datazone.LIVE);
    this.isDataLoaded = true;
     if (!this.showSchedule) {
      this.scheduleLoading = false;
      this.showLoader = false;
      this.envScheduleResponse = false;
      return;
    }
    this.createSchedule = (this.permissionsMap[PermissionKeys.SCHEDULE_CREATE_NONPII] && dataZone === Datazone.NONPII) || (this.permissionsMap[PermissionKeys.SCHEDULE_CREATE_PII] && dataZone === Datazone.PII) || (this.permissionsMap[PermissionKeys.SCHEDULE_CREATE_LIVE] && dataZone === Datazone.LIVE);
    this.isEditScheduleAllowed = (this.permissionsMap[PermissionKeys.SCHEDULE_UPDATE_NONPII] && dataZone === Datazone.NONPII) || (this.permissionsMap[PermissionKeys.SCHEDULE_UPDATE_PII] && dataZone === Datazone.PII) || (this.permissionsMap[PermissionKeys.SCHEDULE_UPDATE_LIVE] && dataZone === Datazone.LIVE);
    this.checkAzureScheduleFeature();
  }

  private checkAzureScheduleFeature(): void {
    this.azureScheduleStateEnabled = this.canAccessFeature(FeatureFlags.AZURE_SCHEDULE_STATE);
  }

  private canAccessFeature(flagId: string): boolean {
    return this.featureFlagsManager.isFeatureEnabled(flagId);
  }

  isAzureScheduleStateAllowed(): boolean {
    return this.isAWS || this.azureScheduleStateEnabled;
  }
  
  onPageChange(event) {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
  }

  onTablePageChanged(event) {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
  }
  
    fetchSchedule(): void {
    this.showLoader = true;
    this.editEnable = false;
    this.selectedData = undefined;
    this.envScheduleService.getSchedule(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(response => {
          response = response?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
          this.scheduleLoading = false;
          this.schedule = response;
          this.deployingStatus = this.schedule.some(item => item.status === 'creating' || item.status === 'updating' || item.status === 'deleting');
          this.schedule?.length > 0 ? this.envScheduleResponse=true: this.envScheduleResponse = false;
          this.data = this.schedule;
          this.showLoader = false;
          this.restrictEnableDisable = this.schedule.some(item => item.status === 'creating' || item.status === 'updating' || item.status === 'deleting' || item.status === 'enabling' || item.status === 'disabling' )
          this.initializeFilterItems();
        },
         (error) => {
          if (error.httpStatusCode === 404){
          this.apiNotFound = true;
        } else {
          this.showLoader = false;
          this.initializeFilterItems();
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
        }
        });
    }
  
    initializeFilterItems(){
    this.runbookVersion = Array.from(
        new Set(this.data?.map((item) => item.componentVersion || '-'))).filter((version) => version && version !== '-').map((version) => ({
          value: version,
          label: version,
          selected: false,
        }));
        this.scheduleStatus = [
        {value: 'created', label: "Created",selected: false},
        {value: 'creating', label: "Creating",selected: false},
        {value: 'updating', label: "Updating",selected: false},
        {value: 'updated', label: "Updated",selected: false},
        {value: 'update_failed', label: "Update Failed",selected: false},
        {value: 'deleting', label: "Deleting",selected: false},
        {value: 'deleted', label: "Deleted",selected: false},
        {value: 'delete_failed', label: "Delete Failed",selected: false},
        {value: 'failed', label: "Failed",selected: false}
      ];
      this.scheduledStatusValue = this.scheduleStatus;
  
      this.runbookType = [
        {value: "Data Screening", label: "Data Screening", selected: false},
        {value: "COB", label: "COB", selected: false},
      ];
  
       const date = [
        {value: 'Modified Date', selected: false}
      ];
  
      this.dropdownsList = [
        {
          title: 'Status',
          placeholder: 'Select Status',
          options: this.scheduleStatus
        },
        {
          title: 'Date',
          placeholder: 'Select Date',
          options: date
        }
      ];
  }
  
  /* Filters the table data based on the currently selected filter criteria */
    filterColumns(): void {
      if(this.scheduleStatus) {
        this.dropdownsList[0].options.filter((item) => {
          if (this.scheduleStatus?.find(status => status === item.value)) {
            item.selected = true;
          }
        });
      }
       if(this.date) {
        this.dropdownsList[1].options.filter((item) => {
          if (item.value === this.date) {
            item.selected = true;
          }
        });
      }
      const data = {
        name: translate('SCHEDULE.SCHEDULE'),
        title: translate('INSTANCE_STATUS.FILTER_TITLE'),
        subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
        filteredColumns: this.dropdownsList,
        dateCreated: this.instance?.dateCreated,
        envScheduleStatusList: this.dropdownsList?.[0].options,
        envScheduleModifiedDate: this.dropdownsList?.[1].options,
        envScheduleStartDateChange: this.dropdownsList?.[1].options?.[0]?.selected ? moment(this.filterStartDate) : '',
        envScheduleStartEndChange: this.dropdownsList?.[1].options?.[0]?.selected ? moment(this.filterEndDate) : '',
        envScheduleColumns: [
          'status',
          'date'
        ]
      };
      this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filteredColumns => {
        this.filteredColumns = filteredColumns;
        if (filteredColumns) {
          this.isFiltered = true;
          this.clearData = true;
          if(filteredColumns[0] !== '') {
            this.scheduleStatus = filteredColumns[0];
          }
          if(filteredColumns[1] !== '') {
            localStorage.removeItem('filteredEnvScheduleDate');
            this.date = filteredColumns[1];
            localStorage.setItem('filteredEnvScheduleDate', JSON.stringify(filteredColumns[1]));
          }
           if (filteredColumns[0]?.length === 0 && filteredColumns[1]?.length === 0){
            this.resetEnvscheduleFilter();
          } else {
            this.filterEnvScheduleItems(filteredColumns);
          }
        }
      });
    }
  
    /* Filters the Runbook table data based on the selected filter criteria. */
    filterEnvScheduleItems(filteredColumns): void {
      if (filteredColumns) {
        this.data = this.schedule;
        this.selectedStatus = [];
        if (filteredColumns[0]?.length > 0) {
          this.selectedStatus = filteredColumns[0];
          if (filteredColumns[0].length > 0) {
            localStorage.setItem('filteredEnvScheduleStatus', JSON.stringify(this.selectedStatus));
            this.data = this.data?.filter(item => this.selectedStatus?.includes(item?.status));
          } else {
            localStorage.removeItem('filteredEnvScheduleStatus');
          }
        }
        if (this.dropdownsList?.[1]?.options?.[0]?.selected && moment(filteredColumns[1][1].filteredStartDate).isValid() && moment(filteredColumns[1][1].filteredEndDate).isValid()) {
          this.filterStartDate = filteredColumns[1][1].filteredStartDate;
          this.filterEndDate = filteredColumns[1][1].filteredEndDate;
          localStorage.setItem('filteredEnvScheduleStartDate', this.filterStartDate);
          localStorage.setItem('filteredEnvScheduleEndDate', this.filterEndDate);
          
          const startDateUTC = moment.utc(moment(this.filterStartDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day');
          const endDateUTC = moment.utc(moment(this.filterEndDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day');
          this.data = this.data?.filter(item => {
            const itemDateUTC = moment.utc(item.updatedAt).startOf('day');
            return itemDateUTC.isSameOrAfter(startDateUTC) && itemDateUTC.isSameOrBefore(endDateUTC);
          });
  
        } else {
          this.filterStartDate = undefined;
          this.filterEndDate = undefined;
          localStorage.removeItem('filteredEnvScheduleStartDate');
          localStorage.removeItem('filteredEnvScheduleEndDate');
        }
      }
    }
  
    /* Returns a label for the Status */
    getStatusLabel(status): void {
        const data = this.selectedStatus?.find(item => item.value === status)?.value || status || '';
        return this.scheduledStatusValue.find(item => item.value === data)?.label;
    }
  
    /* Converts the given date into a UTC timestamp. */
    getUTCTimestamp(date): any {
      return Date.parse(moment(new Date(date)).utc().format('DD MMM YYYY HH:mm:ss'));
    }
  
    /* Cleares the selected Status filter */
    cancelStatusFilter(data) {
      let selectedItem = this.selectedStatus.indexOf(data);
      if (selectedItem > -1) {
        localStorage.removeItem('filteredEnvScheduleStatus');
        this.selectedStatus.splice(selectedItem, 1);
        this.dropdownsList[0].options.find(item => item.value === data).selected = false;
        localStorage.setItem('filteredEnvScheduleStatus', JSON.stringify(this.selectedStatus));
        this.filterEnvScheduleItems(this.filteredColumns);
      }
    }

    /* Cleares the selected Date filter */
    cancelEnvScheduleDateFilter() {
      this.filterStartDate = undefined;
      this.filterEndDate = undefined;
      this.dropdownsList?.[1]?.options?.filter((item) => {item.selected = false});
      this.date?.forEach(element => {
        if(element.includes(this.dropdownsList[1].options[0].value)) {
          this.date.pop(element);
        }
      });
  
      localStorage.removeItem('filteredEnvScheduleStartDate');
      localStorage.removeItem('filteredEnvScheduleEndDate');
      localStorage.removeItem('filteredEnvScheduleCustomDate');
      localStorage.removeItem('filteredEnvScheduleDate');
      this.filterEnvScheduleItems(this.filteredColumns);
    }

    resetPaginator() {
     this.paginatorRef.pageIndex = 0;
    }
  
    /* Reset the selected runbook filter */
    resetEnvscheduleFilter(): void {
      this.isFiltered = false;
      this.selectedStatus = [];
      this.sidenavService.searchFilter.next('data');
      this.dropdownsList?.[0]?.options.filter((item) => {item.selected = false});
      this.dropdownsList?.[1]?.options.filter((item) => {item.selected = false});
      this.status = undefined;
      this.scheduleStatus = undefined;
      this.date = undefined;
      this.filterStartDate = undefined;
      this.filterEndDate = undefined;
      this.data = this.schedule;
      localStorage.removeItem('filteredEnvScheduleStatus');
      localStorage.removeItem('filteredEnvScheduleDate');
      localStorage.removeItem('filteredEnvScheduleStartDate');
      localStorage.removeItem('filteredEnvScheduleEndDate');
    }
    
    refreshClick(): void {
      this.isRefreshing = true;
      this.scheduleLoading = true;
  if (this.isFiltered) {
      setTimeout(() => {
        this.isRefreshing = false;
      this.scheduleLoading = false;
      }, 1000);
      return;
    }
    if (this.paginatorRef) {
    this.paginatorRef.pageIndex = 0;
  }
  this.getInstanceDetails();
  this.fetchSchedule();
  setTimeout(() => {
    this.isRefreshing = false;
    this.scheduleLoading = false;
  }, 1000);
  }
  
    search(searchTerm?: string): void {
      this.searchTerm = searchTerm;
    }
  
    searchedItems(result): void {
      this.searchedResult = result;
      this.cdr.detectChanges();
    }
  
    createClick(): void {
       const tenantId = this.activatedRoute.snapshot.params.id;
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , tenantId, RouterSegments.BLUEPRINTS, this.activatedRoute.snapshot.params.blueprintId, 
      RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId, RouterSegments.CREATE_SCHEDULE]);
    }

    editSchedule(data): void {
      const tenantId = this.activatedRoute.snapshot.params.id;
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , tenantId, RouterSegments.BLUEPRINTS, this.activatedRoute.snapshot.params.blueprintId, 
      RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId, RouterSegments.EDIT_SCHEDULE, data?.id]);
    }

    getApproveData(data): void {
    this.editEnable = true;
    this.selectedData = data;
  }

  onDisableSchedule(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('SCHEDULES.DISABLE_TITLE'),
        message: translate('SCHEDULES.DISABLE_MESSAGE'),
        scheduleName: this.selectedData.name.includes('-') ? this.selectedData.name.split('-')[0].trim() : this.selectedData.name,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
        this.envScheduleService.scheduleDisable(this.instanceId, this.selectedData.id)
        .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(data => {
            if (data?.httpStatusCode === 202) {
              this.fetchSchedule();
              setTimeout(() => {
                const title = translate('TENANT_LAYOUT.MENU.SCHEDULE');
                const message = translate('SCHEDULE.DISABLED_SUCCESS_MSG');
                this.toastrService.successMessage(message, title);
              }, 500);
            }
          }, (error) => {
            const description = error?.message 
            || error?.error?.message 
            || error?.errmsg 
            || translate('SERVICE.INTERNAL_SERVER_ERROR');
            setTimeout(() => {
              this.openErrorDialog(error);
            }, 500);
          })
      }
  })
    
  }

  onEnableSchedule(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('SCHEDULES.ENABLE_TITLE'),
        message: translate('SCHEDULES.ENABLE_MESSAGE'),
        scheduleName: this.selectedData.name.includes('-') ? this.selectedData.name.split('-')[0].trim() : this.selectedData.name,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if (confirm) {
      this.envScheduleService.scheduleEnable(this.instanceId, this.selectedData.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(data => {
          if (data?.httpStatusCode === 202) {
            this.fetchSchedule();
            setTimeout(() => {
              const title = translate('TENANT_LAYOUT.MENU.SCHEDULE');
              const message = translate('SCHEDULE.ENABLED_SUCCESS_MSG'); 
              this.toastrService.successMessage(message, title);
            }, 500);
          }
        }, (error) => {
          const description = error?.message 
          || error?.error?.message 
          || error?.errmsg 
          || translate('SERVICE.INTERNAL_SERVER_ERROR');
          setTimeout(() => {
            this.openErrorDialog(error);
          }, 500);
        })
    }
})
}

  
  // Error block
  openErrorDialog(data): void {
    this.dialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('SCHEDULE_DETAILS.SCHEDULE_VALIDATION_ERROR'),
        descriptionError: data
      }
    });
  }

  redirectToJobs(event){
    this.goToJobs.emit(event);
  }

  private getInstanceDetails(): void {
    const instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.instanceService.getInstanceDetails(instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.instance = data;
        }
      },
      (error) => {
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  private async getDataZone() {
    const instance = this.instance ?? this.EditRunbookService.getInstance() ?? (await this.waitForInstance());
    return instance.dataZone;
  }

  private async waitForInstance() {
    let instance = this.instance;
    if (instance) return instance;
    while (!instance) {
      if (this.instance) {
        instance = this.instance;
        break;
      }
      const serviceInstance = this.EditRunbookService.getInstance();
      if (serviceInstance) {
        instance = serviceInstance;
        break;
      }
      await new Promise(resolve => setTimeout(resolve, 50));
    }
    return instance;
  }

  private async initDataZone() {
    const dataZone = await this.getDataZone();
    return dataZone;
  }

  }

